export default "__VITE_ASSET__b3dDt67e__"